import { millisecondsToSeconds } from 'date-fns';

import { SET_TIMER } from './constants';

export function setTimer() {
    return {
        type: SET_TIMER,
        payload: { time: millisecondsToSeconds(Date.now()) },
    };
}
